export const COMPANY = {
  API_BASE_URL : "http://72.60.99.84",
  NAME: " Alderleaf Stock mantra  Pvt Ltd.",
  SHORT_NAME: "Alderleaf Stock mantra ",
  SEBI_REG_NO: "INH000019099 ",
  SEBI_REG_DATE: "Mar 19, 2024",

  ADDRESS:
    "Renuka Shobha Fl 604 Sno., Chinchwad, Chindhwadgaon, Mulshi, Pune, Maharashtra, 411033",

  CONTACT: {
    PHONE: "7977117177",
    EMAIL: "support@alstockmantra.in",
  },

  FEES: {
    MAX_PER_YEAR: "₹1.51 lakhs",
  },

  LINKS: {
    SCORES: "https://scores.sebi.gov.in",
    SMART_ODR: "https://smartodr.in",
  },
};
